import React from 'react';
import { TableCell, TableFooter, TableRow } from '@material-ui/core';

import { floatRenderer } from '../../../../services/formatSvc';
import {
  editComponentsHelper, filtersHelper, highlightNegative, renderTooltip,
} from './Shared';
import FilterMultiSelect from '../../../../components/table/FilterMultiSelect';

export const getColumns = (props) => [
  {
    title: 'Год',
    field: 'year',
    minWidth: 100,
    maxWidth: 100,
    lookup: filtersHelper.getYearsLookup(),
    filterComponent: ({ columnDef, onFilterChanged })=><FilterMultiSelect columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={props.MTableFiltersRef} field="year" />,
    editable: 'onAdd',
    editComponent: editComponentsHelper.getYearControl,
  },
  {
    title: 'Соглашение',
    field: 'agreementId',
    minWidth: 170,
    maxWidth: 170,
    lookup: filtersHelper.getAgreementLookup(props.plansDictionary),
    filterComponent: ({ columnDef, onFilterChanged })=><FilterMultiSelect columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={props.MTableFiltersRef} field="agreementId" />,
    editable: 'onAdd',
    editComponent: editComponentsHelper.getAgreementControl(props),
    render: ({ agreementNum, agreement }) => renderTooltip(agreementNum, agreement),
  },
  {
    title: 'Тип финансирования',
    field: 'fundingId',
    minWidth: 120,
    maxWidth: 120,
    lookup: filtersHelper.getFundingLookup(props.plansDictionary),
    filterComponent: ({ columnDef, onFilterChanged })=><FilterMultiSelect columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={props.MTableFiltersRef} field="fundingId" />,
    editable: 'onAdd',
    editComponent: editComponentsHelper.getFundingControl(props),
    render: ({ funding }) => funding,
  },
  {
    title: 'Код статьи соглашения',
    field: 'costAgrId',
    minWidth: 100,
    maxWidth: 100,
    lookup: filtersHelper.getCostAgrsNumLookup(props.plansDictionary),
    filterComponent: ({ columnDef, onFilterChanged })=><FilterMultiSelect columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={props.MTableFiltersRef} field="costAgrId" />,
    editable: 'onAdd',
    editComponent: editComponentsHelper.getCostAgrsControl(props),
    render: (rowData) => rowData.costAgrNum,
  },
  {
    title: 'Наименование статьи затрат (соглашение)',
    field: 'costAgrName',
    lookup: filtersHelper.getCostAgrsNameLookup(props.plansDictionary),
    filterComponent: ({ columnDef, onFilterChanged })=><FilterMultiSelect columnDef={columnDef} onFilterChanged={onFilterChanged} MTableFiltersRef={props.MTableFiltersRef} field="costAgrName" />,
    editable: 'onAdd',
    filterCellStyle: { minWidth: '300px', maxWidth: '300px' },
    editComponent: editComponentsHelper.getCostAgrsLabel(props),
  },
  {
    title: 'План по соглашению, руб.',
    field: 'plan',
    minWidth: 140,
    filterCellStyle: { minWidth: '140px', maxWidth: '140px' },
    filtering: false,
    editComponent: editComponentsHelper.getMonetaryControl,
    render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.plan),
  },
  {
    title: 'Сумма введено по закупкам, руб.',
    field: 'factSum',
    minWidth: 140,
    filterCellStyle: { minWidth: '140px', maxWidth: '140px' },
    filtering: false,
    editable: 'never',
    render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.factSum),
  },
  {
    title: 'Остаток от плана по согл. по введ. закупкам, руб.',
    field: 'factRemainder',
    minWidth: 140,
    filterCellStyle: { minWidth: '140px', maxWidth: '140px' },
    filtering: false,
    editable: 'never',
    render: (rowData) => highlightNegative(rowData.factRemainder),
  },
  {
    title: 'Сумма утверждено по закупкам, руб.',
    field: 'approvedSum',
    minWidth: 140,
    filterCellStyle: { minWidth: '140px', maxWidth: '140px' },
    filtering: false,
    editable: 'never',
    render: (rowData) => new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(rowData.approvedSum),
  },
  {
    title: 'Неутвержденный остаток от плана по согл., руб.',
    field: 'approvedRemainder',
    minWidth: 140,
    filterCellStyle: { minWidth: '140px', maxWidth: '140px' },
    filtering: false,
    editable: 'never',
    render: (rowData) => highlightNegative(rowData.approvedRemainder),
  },
];

const getSumByField = (data, fieldName) => data.reduce((acc, row) => acc + (row[fieldName] || 0), 0);

export const getFooter = (data) => {
  const totals = [
    getSumByField(data, 'plan'),
    getSumByField(data, 'factSum'),
    getSumByField(data, 'factRemainder'),
    getSumByField(data, 'approvedSum'),
    getSumByField(data, 'approvedRemainder'),
  ];

  return (
    <TableFooter style={{ position: 'sticky', bottom: '0' }}>
      <TableRow style={{ backgroundColor: '#FFF' }}>
        <TableCell colSpan={5} />
        <TableCell style={styleBlackBold}>
          Итог
        </TableCell>
        {
          totals.map((v, i) => (
            <TableCell key={`total_${i}`} style={styleBlackBold}>
              {new Intl.NumberFormat("ru", { minimumFractionDigits: 2 }).format(v)}
            </TableCell>
          ))
        }
      </TableRow>
    </TableFooter>
  );
};

const styleBlackBold = { color: 'black', fontWeight: 'bold' };
